import { render, staticRenderFns } from "./loversSpot.vue?vue&type=template&id=5e0c07e4&scoped=true"
import script from "./loversSpot.vue?vue&type=script&lang=js"
export * from "./loversSpot.vue?vue&type=script&lang=js"
import style0 from "./loversSpot.vue?vue&type=style&index=0&id=5e0c07e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c07e4",
  null
  
)

export default component.exports